<template>
  <div>
    <div class="common-header-wrap">
      <mt-header title="地图选点" class="common-header">
        <mt-button slot="left" icon="back" @click="goBack"></mt-button>
      </mt-header>
    </div>
    <div class="wrapper">
      <input v-model="keyword" class="input" @keyup.enter="searchAddress()" />
      <i class="iconfont search-btn" @click="searchAddress()">&#xe629;</i>
      <div id="gaode_map"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { loadScript } from '../util/common'
import { gaodeMap } from '../api/memberAddress'
export default {
  name: 'GaodeMap',
  data () {
    return {
      map: false,
      placeSearch: false,
      keyword: ''
    }
  },
  props: {
    addressInfo: {},
    ifComponent: {
      type: Boolean,
      default: false
    },
    longitude: { default: 0 },
    latitude: { default: 0 }
  },
  mounted () {
    let _this = this
    loadScript('gaode', 'https://webapi.amap.com/maps?v=1.4.15&key=' + this.config.gaode_js_key + '&plugin=AMap.Autocomplete', function () {
      var lng = _this.longitude
      var lat = _this.latitude
      var mapOption = { resizeEnable: true, zoom: 11 }
      if (lng && lat) {
        mapOption['center'] = [lng, lat]
      }
      var placeSearch
      var map = new AMap.Map('gaode_map', mapOption)
      AMap.plugin('AMap.PlaceSearch', function () {
        var autoOptions = {
          city: '全国'
        }
        placeSearch = new AMap.PlaceSearch(autoOptions)
      })
      _this.map = map
      if (lng && lat) {
        _this.addMarker(lng, lat)
      } else {
        if (_this.keyword) {
          _this.searchAddress()
        }
      }
      // 为地图注册click事件获取鼠标点击出的经纬度坐标
      map.on('click', function (e) {
        map.clearMap()
        _this.addMarker(e.lnglat.getLng(), e.lnglat.getLat())
      })
      _this.placeSearch = placeSearch
      if (_this.addressInfo) {
        _this.searchAddress(_this.addressInfo.area_info + _this.addressInfo.address_detail)
      }
    })
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    })
  },
  created () {

  },
  methods: {
    goBack () {
      if (this.ifComponent) {
        this.$emit('closeMap')
      } else {
        if (this.addressInfo) {
          MessageBox.confirm('你确定所选位置是' + this.addressInfo.address_detail + '吗？').then(action => {
            this.$router.go(-1)
          })
        } else {
          this.$router.go(-1)
        }
      }
    },
    searchAddress (keyword = '', ifInit = false) {
      if (!keyword) {
        keyword = this.keyword
      } else {
        this.keyword = keyword
        if (ifInit) {
          return
        }
      }
      var _this = this
      this.placeSearch.search(keyword, function (status, result) {
        // 搜索成功时，result即是对应的匹配数据
        if (status == 'complete' && result.info == 'OK' && result.poiList.count) {
          _this.map.clearMap()
          _this.addMarker(result.poiList.pois[0].location.lng, result.poiList.pois[0].location.lat)
        }
      })
    },
    addMarker (lng, lat) {
      var marker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat)
      })
      this.map.add(marker)
      this.map.setCenter([lng, lat]) // 设置地图中心点
      if (this.ifComponent) {
        this.$emit('setPostion', lng, lat)
      } else {
        if (this.addressInfo) {
          gaodeMap(this.addressInfo.address_id, lng, lat).then(res => {

          }).catch(error => {
            Toast(error.message)
          })
        }
      }
    }
  }
}
</script>
<style  lang="scss" scoped>
  .wrapper{position:absolute;top:2rem;bottom:0;left:0;right:0;}
  #gaode_map{width:100%;height:100%;}
  .input{position: absolute;top:1rem;width:80%;left:10%;line-height: 2rem;border-radius: .2rem;z-index: 2;padding:0 .5rem;box-sizing: border-box;font-size:.7rem;}
    .search-btn{position: absolute;top:1rem;right:11%;font-size: 1rem;z-index: 3;line-height: 2rem;}
</style>
